module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-large.7ed8dab2.jpg";